const paymentConditions = [
  "شهریه پرداختی بابت 12 جلسه تمرینی می‌باشد",
  "شهریه بعد از پرداخت، استرداد نمی‌شود",
  "اگر به هر دلیلی از کل کلاس، یا جلساتی استفاده ننمائید، کلاس به ترم دیگری قابل انتقال نیست",
];

export default paymentConditions